import {
  GET_EVENTS_FAILURE,
  GET_EVENTS_REQUEST,
  GET_EVENTS_SUCCESS,
  SEND_EVENT_FAILURE,
  SEND_EVENT_REQUEST,
  SEND_EVENT_SUCCESS,
  GetEventsFailureAction,
  GetEventsRequestAction,
  GetEventsSuccessAction,
  SendEventFailureAction,
  SendEventRequestAction,
  SendEventSuccessAction,
} from './events.types';
import { Event, SendEventPayload } from 'types/events.types';

export const getEventsRequest = (): GetEventsRequestAction => ({
  type: GET_EVENTS_REQUEST,
});

export const getEventsSuccess = (payload: Event[]): GetEventsSuccessAction => ({
  type: GET_EVENTS_SUCCESS,
  payload: payload,
});

export const getEventsFailure = (error: string): GetEventsFailureAction => ({
  type: GET_EVENTS_FAILURE,
  payload: error,
});

export const sendEventRequest = (
  payload: SendEventPayload
): SendEventRequestAction => ({
  type: SEND_EVENT_REQUEST,
  payload,
});

export const sendEventSuccess = (): SendEventSuccessAction => ({
  type: SEND_EVENT_SUCCESS,
});

export const sendEventFailure = (error: string): SendEventFailureAction => ({
  type: SEND_EVENT_FAILURE,
  payload: error,
});
